(() => {
  document.querySelectorAll('[data-towa-article-body]').forEach((body) => {
    const container = body.closest('.article-template__content');
    const toc = container && container.querySelector('.towa-article-toc');
    if (!toc) return;
    const headings = [...body.querySelectorAll('h2')];
    if (headings.length < 2) return;
    const list = toc.querySelector('ol');
    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `section-${index + 1}`;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      item.appendChild(link);
      list.appendChild(item);
    });
    toc.hidden = false;
  });
})();
